import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import constants from './modules/constants'
import transaction from './modules/transaction'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        user,
        constants,
        transaction
    },
    getters: {
    },
    strict: debug,
    mutations: {
        resetOwner(state) {
            state.user.access_token = null
            state.user.id = null
            state.user.stagename = null
            state.user.phone = null
            state.user.avatar = null

            state.shop.owner = {}
            state.shop.items = {}
            state.shop.whatsapp_status = false
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js